import { render } from "./MarkdownViewer.vue?vue&type=template&id=1d778477&ts=true"
import script from "./MarkdownViewer.vue?vue&type=script&lang=ts"
export * from "./MarkdownViewer.vue?vue&type=script&lang=ts"

import "./MarkdownViewer.vue?vue&type=style&index=0&id=1d778477&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__